import React, { useState } from "react";

import { Heading2, Search } from "widgets";
import { useSearchPackage } from "store/backend/apiHooks";

import styles from "./SearchPackage.module.scss";

const handleOnChangeSearch = (inputValue, setSearchTerm) => {
  setSearchTerm(inputValue);
};

const handleOnSelectSearchItem = (selectedItem, onPackageSelect) => {
  if (onPackageSelect) {
    onPackageSelect(selectedItem);
  }
};

const SearchPackage = ({ onPackageSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading, error } = useSearchPackage(searchTerm, !!searchTerm);

  return (
    <div className={styles.searchFieldContainer}>
      <Heading2 heading="Search Package" />
      <div className={styles.searchField}>
        <Search
          id="search-package"
          name="searchPackage"
          label="Search by Internal Package Name"
          options={data || []}
          placeholder="Type to search"
          getOptionLabel={(option) => option.name || ""}
          handleOnChangeSearch={(inputValue) => handleOnChangeSearch(inputValue, setSearchTerm)}
          handleOnSelectSearchItem={(selectedItem) => handleOnSelectSearchItem(selectedItem, onPackageSelect)}
          isOptionEqualToValue={(option, value) => option.package_id === value.package_id}
          loading={isLoading}
        />
      </div>
      {error && <div className={styles.error}>Error: {error.message}</div>}
    </div>
  );
};

export default SearchPackage;
